(function () {
  function getBreadcrumbLast() {
    return document.querySelector('#breadcrumbs .breadcrumb_last');
  }

  function getProductTitle() {
    const items = [...document.querySelectorAll('#breadcrumbs > li')];
    const productItem = items.find(
      (item) => !item.classList.contains('breadcrumb_last') && !item.classList.contains('breadcrumb_first')
    );

    if (productItem) {
      const linkText = productItem.querySelector('a')?.textContent?.trim();
      if (linkText) return linkText;
    }

    return document.querySelector('.product__title')?.textContent?.trim() || '';
  }

  function formatBreadcrumbLabel(variant, productTitle) {
    
    if (variant.name && variant.name !== 'Default Title') {
      return variant.name;
    };
    
    if (!variant) return productTitle;

    return productTitle;
  }

  function updateBreadcrumb(variant) {
    const breadcrumbLast = getBreadcrumbLast();
    if (!breadcrumbLast) return;

    const label = formatBreadcrumbLabel(variant, getProductTitle());
    const currentPage = breadcrumbLast.querySelector('[aria-current="page"]');

    if (currentPage) {
      currentPage.textContent = label;
      return;
    }

    const span = document.createElement('span');
    span.setAttribute('aria-current', 'page');
    span.textContent = label;
    breadcrumbLast.replaceChildren(span);
  }

  function getSelectedVariant() {
    const variantJson = document.querySelector('variant-selects [data-selected-variant]')?.textContent;

    if (!variantJson) return null;

    try {
      return JSON.parse(variantJson);
    } catch {
      return null;
    }
  }

  function syncBreadcrumb() {
    updateBreadcrumb(getSelectedVariant());
  }

  function init() {
    if (!getBreadcrumbLast() || !document.querySelector('product-info')) return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      updateBreadcrumb(data?.variant || null);
    });

    syncBreadcrumb();

    document.addEventListener('product-info:loaded', syncBreadcrumb);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
